import type { ApiS3File } from '#/api/types/ApiS3File';
import type { ApiS3FileId } from '#/api/types/ApiTypedId';
import { FetchEndpoint } from '#/utils/endpoint/FetchEndpoint';

type ApiResponse = {
  s3File: ApiS3File;
};

function mapResponse(response: ApiResponse) {
  return response.s3File;
}

const endpoint = new FetchEndpoint({
  urlFactory: (fileId: ApiS3FileId | null) => {
    if (!fileId) return;
    return `/data/s3-uploads/${fileId}/meta`;
  },
  mapResponse,
});

// Exports

export const apiClientFetchS3FileMeta = endpoint.createClientFetchFn();

export const useApiClientFetchS3FileMeta = endpoint.createUseFetchHook();
